import { signal, computed } from '@angular/core';
import {
  AssessmentPresetFormType,
  CheckpointFormType,
  createAssessmentPresetForm,
  createCheckpointForm
} from '@pages/checkpoint-detail-page/checkpoint-utils';

export class CheckpointFormWrapper {
  private readonly _form = signal<CheckpointFormType>(createCheckpointForm());

  readonly form = computed(() => this._form());

  readonly controls = computed(() => this._form().controls);

  readonly dirty = computed(() => this._form().dirty);
  readonly disabled = computed(() => this._form().disabled);

  setForm(form: CheckpointFormType) {
    this._form.set(form);
  }

  enable(): void {
    this._form().enable({ emitEvent: false });
  }

  disable(): void {
    this._form().disable({ emitEvent: false });
  }

  valid(): boolean {
    return this._form().valid;
  }

  markAllAsTouched(): void {
    this._form().markAllAsTouched();
  }

  markAsPristine(): void {
    this._form().markAsPristine();
  }

  addAssessmentPreset(): void {
    const preset = createAssessmentPresetForm();
    this.keepStandardAssessmentExclusive(preset);
    this._form().controls.assessmentPresets.insert(0, preset);
  }

  keepStandardAssessmentExclusive(preset: AssessmentPresetFormType): void {
    preset.controls.standardAssessment.valueChanges.subscribe((isStandard) => {
      if (!isStandard) return;
      this._form().controls.assessmentPresets.controls
        .filter((other) => other !== preset)
        .forEach((other) => other.controls.standardAssessment.setValue(false));
    });
  }

  removeAssessmentPreset(index: number): void {
    this._form().controls.assessmentPresets.removeAt(index);
  }

  getMappedValue(): ReturnType<CheckpointFormType['getMappedValue']> {
    return this._form().getMappedValue();
  }
}
